export type ThemePreference = 'system' | 'light' | 'dark';
const THEME_KEY = 'route42:theme';

export function getThemePreference(): ThemePreference {
  try {
    const stored = localStorage.getItem(THEME_KEY);
    return stored === 'light' || stored === 'dark' ? stored : 'system';
  } catch {
    return 'system';
  }
}

export function applyTheme(preference: ThemePreference): void {
  const actual =
    preference === 'system'
      ? window.matchMedia('(prefers-color-scheme: dark)').matches
        ? 'dark'
        : 'light'
      : preference;
  document.documentElement.dataset.bsTheme = actual;
  document.querySelector<HTMLMetaElement>('meta[name="theme-color"]')?.setAttribute(
    'content',
    actual === 'dark' ? '#0f1115' : '#f5f7f9',
  );
  try {
    localStorage.setItem(THEME_KEY, preference);
  } catch {
    // Theme still applies for this session even when browser storage is unavailable.
  }
}
